import React, { useEffect, useState } from 'react';

import type { CompanyInfoDTO, UserDTO } from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';

import Card from '../../../components/common/Card';
import CompanyInfoForm from '../../../components/forms/CompanyInfoForm';
import AdminLayout from '../../../components/layout/AdminLayout';
import { useCompanyInfoApi } from '../../../hooks/useCompanyInfoApi';

const CompanyInfoEdit: React.FC = () => {
  const [companyInfo, setCompanyInfo] = useState<CompanyInfoDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { edit, getById } = useCompanyInfoApi();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Company Info', href: '/admin/companyinfo' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchCompanyInfo = async (): Promise<void> => {
      try {
        if (id) {
          const response = await getById(id);
          if (response) {
            setCompanyInfo(response.data || null);
          }
        }
      } catch (error) {
        console.error('Error fetching company info:', error);
      }
    };

    fetchCompanyInfo();
  }, [id]);

  const handleSubmit = async (data: UserDTO): Promise<void> => {
    setIsSubmitting(true);
    try {
      if (id) {
        await edit(id, data);
        navigate('/admin/companyinfo');
      }
    } catch (error) {
      console.error('Error updating company info:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/companyinfo"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
    >
        {companyInfo ? (
          <CompanyInfoForm
            initialValues={companyInfo}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/companyinfo')}
            isSubmitting={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CompanyInfoEdit;
